export default __webpack_public_path__ + "static/media/stats-icon.e4eb285e.svg";